import React from 'react';
import PropTypes from 'prop-types';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import cn from 'classname';

const propTypes = {
	items: PropTypes.array.isRequired,
	ghostItemWrapIndex: PropTypes.number
};

const SortableItem = SortableElement(({value, isGhost}) => (
	<div className={cn(
		'sortable-order__list-item-wrap',
		isGhost && 'sortable-order__list-item-wrap--ghost'
	)}>{value}</div>
));

const Container = SortableContainer(({items, ghostItemWrapIndex}) => (
	<div className="sortable-order__list">
		{items.map((value, index) => (
			<SortableItem key={`item-${index}`} index={index} value={value} isGhost={ghostItemWrapIndex === index} />
		))}
	</div>
));

Container.propTypes = propTypes;
export default Container;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/order-list/container.js